import { Menu, MenuItem, Tooltip } from '@mui/material';
import { ReactNode } from 'react';

export interface MenuAction {
  label: string;
  color?: string; 
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
}

interface ContextMenuProps {
  open: boolean;
  onClose: () => void;
  mouseX: number;
  mouseY: number;
  actions: MenuAction[];
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  open,
  onClose,
  mouseX,
  mouseY,
  actions
}) => {
  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        open
          ? { top: mouseY, left: mouseX }
          : undefined
      }
      data-testid="context-menu"
    >
      {actions.map((action, index) => {
        const menuItem = (
          <MenuItem
            key={index}
            onClick={action.onClick}
            disabled={action.disabled}
            data-testid={`context-menu-item-${action.label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            {action.icon}
            <span style={{ marginLeft: 8, color: action.color ? action.color : 'inherit' }}>{action.label}</span>
          </MenuItem>
        );

        return action.tooltip ? (
          <Tooltip key={index} title={action.tooltip} placement="right">
            {menuItem}
          </Tooltip>
        ) : menuItem;
      })}
    </Menu>
  );
};

export default ContextMenu; 